import { createChannelManagementInstance } from '../api-instance';
import type { TRequestOptions } from '../types';
import type { IChannelDetailsDto } from './types';

export interface VkAuthorizeRequest {
  token: string;
  group_id: string;
}

export const updateVkChannel = (
  channelId: string,
  data: VkAuthorizeRequest,
  options?: TRequestOptions
): Promise<IChannelDetailsDto> =>
  createChannelManagementInstance<IChannelDetailsDto>(
    {
      url: `/api/v1/channels/vk/${encodeURIComponent(channelId)}`,
      method: 'PUT',
      data,
    },
    options
  );
